
import axiosInstance from './axiosInstance';

export const fetchTravelActivity = async (data) => {
  const res = await axiosInstance.post('/travel/travel_history',data);
  const raw = res.data?.data?.[0]?.get_user_travel_details;
  return raw || [];
};


export const fetchAttendenceReport= async (data) => {
  const res = await axiosInstance.post('/travel/attendance_report',data);
  const raw = res.data?.data?.[0]?.get_user_attendance_details;
  return raw || [];
};

export const fetchDailyAttendence= async (data) => {
  const res = await axiosInstance.post('/travel/attendance',data);
  const raw = res.data?.data;
  return raw || [];
};

export const fetchSummaryReport= async (data) => {
  const res = await axiosInstance.post('/travel/get_empwise_travel_summary',data);
  const raw = res.data?.data
  return raw || [];
};


export const approveExpense= async (data) => {
  const res = await axiosInstance.post('/travel/upsert_expense_approval',data);
  const raw = res.data?.data
  return raw || [];
};

export const fetchTravelData= async (data) => {
  const res = await axiosInstance.post('/travel/get_travel_data',data);
  const raw = res.data?.data
  return raw || [];
};

export const approveTravelData= async (data) => {
  const res = await axiosInstance.post('/travel/travel_update',data);
  const raw = res.data?.data
  return raw || [];
};

export const getExpenseIamges= async (data) => {
  const res = await axiosInstance.post('/expense/get-expense-images',data);
  const raw = res.data?.data
  return raw || [];
};

export const fetchExpenseReport = async (data) => {
  const res = await axiosInstance.post('/travel/get_expenses_report', data);
  const raw = res.data?.data || [];
  return raw.map(x => x.fn_get_empwise_expenses);
};

export const SendMail = async (data) => {
  const res = await axiosInstance.post('/travel/travel_approval_mail', data);
  const raw = res.data?.data
  return raw || [];
};